import React from "react";
import { RefluxComponent } from "sp-react-commons";

import UserStore from "../../stores/UserStore";
import UserActions from "../../actions/UserActions";

import UserHeaderDropdownPresenter from "./UserHeaderDropdownPresenter";


export default class UserHeaderDropdown extends RefluxComponent {
    initialState = () => ({
        loading: true,
        collapsed: true,
        jqueryInitialized: false
    });

    constructor() {
        super();
        this.state = this.initialState();
    }

    componentDidMount() {
        this.listenTo(UserStore, this._onStoreChange);
        UserActions.getUser();
    }

    htmlEvents = () => {
        $('.mywort-dropdown__content, .mywort-header__sub__menu').slideUp(200);
        $(".mywort-dropdown--open").removeClass('mywort-dropdown--open');
        $('html').off('click', this.htmlEvents);
    };

    jqueryEvents = () => {
        if(this.state.jqueryInitialized){
            return;
        }

        this.setState({jqueryInitialized:true});
        var that = this;
        $('.mywort-header__user-btn, .mywort-header__language-btn').click(function(e) {
            $('html').click(that.htmlEvents);
            $(".menu-items").css("border-top","");
            $('.header-dropdown > .mywort-dropdown__content').slideToggle(200);
            $('.mywort-header').css('overflow','visible');
            $(this).toggleClass('mywort-dropdown--open');
            e.stopPropagation();
        });
    };

    _onStoreChange = (data) => {
        this.setState({loading: false});
        this.setState({ user: data.user });
        this.jqueryEvents();
    };

    render = () => {
        if(this.state.loading) {
            return <div className="header-dropdown--loader"/>;
        }

        return <UserHeaderDropdownPresenter user={this.state.user} />;
    };
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/user-header-dropdown/UserHeaderDropdown.jsx